import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../../helpers/Helpers';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import TableFooter from '../../../../components/TableFooter';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../../components/RefreshButton';
import { useSortableColumns } from '../../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../../models/common/ColumnFilterModel';
import { loadList } from '../../../../components/ColumnFilter/columnFilterOptions';
import { CompanyService } from '../../../../services/CompanyService';
import { FARKLI_DOVIZ } from '../../../../helpers/dipToplam';
import { sayiYaz } from '../../../../helpers/yakitHesap';
import { ilkYakitListIstegi, YAKIT_SAYFASI, YakitKaydi, YakitListIstegi, YakitSecenek, YakitSecenekleri, YakitService, YakitToplamlari } from '../../../../services/YakitService';
import YakitListFilters from './Components/YakitListFilters';
import YakitIceAktarModal from './Components/YakitIceAktarModal';

/**
 * Genel Giderler > Yakıt Kayıtları (27.10.2026, #490): standart liste ekranı. Brief'teki panel filtreleri (plaka, tarih
 * aralığı, sürücü, yakıt türü) 22.09.2026 standardına göre kolon filtresi; arama kutusu belge no, açıklama ve sefer no arar.
 * Miktar ve tutarlar fişin satır toplamları; dip toplamlar filtreye uyan bütün kayıtlar üzerinden (sunucuda).
 */
const YakitList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = YAKIT_SAYFASI
    const pageVersion = "1";
    const [data, setData] = useState<{ list: YakitKaydi[], totalRecordCount: number, toplamlar?: YakitToplamlari }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<YakitListIstegi>(ilkYakitListIstegi)
    const [iceAktarAcik, setIceAktarAcik] = useState<boolean>(false);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Plaka', name: 'plaka', order: 0, isVisible: true },
            { title: 'Belge No', name: 'belgeNo', order: 0, isVisible: true },
            { title: 'İşlem Tarihi', name: 'islemTarihiStr', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'surucu', order: 0, isVisible: true },
            { title: 'Sefer No', name: 'seferNo', order: 0, isVisible: true },
            { title: 'Yakıt Türü', name: 'yakitTurleri', order: 0, isVisible: true },
            { title: 'Miktar', name: 'toplamMiktar', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Toplam Tutar', name: 'toplamNet', order: 0, isVisible: true, className: 'text-end' },
            { title: 'KDV Tutar', name: 'toplamKdv', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Brüt Toplam', name: 'toplamBrut', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Döviz', name: 'dovizCinsi', order: 0, isVisible: false },
            { title: 'Brüt (TL)', name: 'toplamBrutTL', order: 0, isVisible: false, className: 'text-end' },
            { title: 'Açıklama', name: 'aciklama', order: 0, isVisible: true },
            { title: 'Araç Cinsi', name: 'aracCinsi', order: 0, isVisible: false },
            { title: 'Yakıt Firması', name: 'yakitFirmasi', order: 0, isVisible: false },
            { title: 'Kilometre', name: 'kilometre', order: 0, isVisible: false, className: 'text-end' },
            { title: 'Saat', name: 'islemSaati', order: 0, isVisible: false },
            { title: 'Sefer Durumu', name: 'seferDurumu', order: 0, isVisible: false },
            { title: 'Kaynak', name: 'kaynakAdi', order: 0, isVisible: false }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const updateKayit = async (_id: string | undefined = undefined) => {
        navigate('/yakit/listadd?id=' + (_id ? _id : data.list.filter(x => x.isSelected)[0].yakitKaydiId));
    }

    const deleteKayit = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.sil(data.list.filter(x => x.isSelected).map(x => x.yakitKaydiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen kayıtlar silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: YakitListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await YakitService.getList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.yakitKaydiId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData({ ...filter, currentPage: 1, skip: 0 });
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.exportList(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.yakitKaydiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const ornekExcel = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.ornekExcel();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Seçimli kolon filtrelerinin seçenekleri tek istekte gelir; ilk açılan kolon yükler, diğerleri hatırlar.
    const secenekler = useRef<Promise<YakitSecenekleri> | undefined>(undefined);

    const secenekYukle = (al: (s: YakitSecenekleri) => YakitSecenek[]) => async (): Promise<ColumnFilterOption[]> => {
        if (!secenekler.current)
            secenekler.current = YakitService.secenekler().then(r => {
                if (!r.isSuccess)
                    throw r.message;
                return r.data as YakitSecenekleri;
            });

        try {
            return al(await secenekler.current).map(x => ({ value: x.value, label: x.label }));
        } catch (error: any) {
            secenekler.current = undefined;
            toast.error(error);
            return [];
        }
    }

    const listeYukle = (cagri: () => Promise<any>) => async (): Promise<ColumnFilterOption[]> => {
        var response = await cagri();

        return response.isSuccess ? (response.data as YakitSecenek[]).map(x => ({ value: x.value, label: x.label })) : [];
    }

    // Kolon adları backend'deki eşlemeyle (YakitListe) aynı.
    const sortableColumns = ['plaka', 'belgeNo', 'islemTarihiStr', 'surucu', 'seferNo', 'yakitTurleri', 'toplamMiktar', 'toplamNet', 'toplamKdv', 'toplamBrut', 'aracCinsi', 'yakitFirmasi', 'kilometre', 'dovizCinsi', 'toplamBrutTL'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        plaka: { type: 'select', allowEmpty: false, loadOptions: listeYukle(() => YakitService.plakalar()) },
        belgeNo: { type: 'text' },
        islemTarihiStr: { type: 'date' },
        islemSaati: { type: 'text' },
        surucu: { type: 'select', allowEmpty: false, loadOptions: listeYukle(() => YakitService.suruculer()) },
        seferNo: { type: 'text' },
        seferDurumu: { type: 'text' },
        yakitTurleri: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.yakitTurleri) },
        toplamMiktar: { type: 'number' },
        toplamNet: { type: 'number' },
        toplamKdv: { type: 'number' },
        toplamBrut: { type: 'number' },
        dovizCinsi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.dovizCinsleri) },
        toplamBrutTL: { type: 'number' },
        aciklama: { type: 'text' },
        aracCinsi: { type: 'text' },
        yakitFirmasi: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        kilometre: { type: 'number' },
        kaynakAdi: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: YakitKaydi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger = item2[column];

        if (column == 'toplamNet' || column == 'toplamKdv' || column == 'toplamBrut' || column == 'toplamBrutTL')
            deger = sayiYaz(deger) + (column != 'toplamBrutTL' && item.dovizCinsi && item.dovizCinsi != 'TRY' && item.dovizCinsi != 'TL' ? ' ' + item.dovizCinsi : '');
        else if (column == 'toplamMiktar')
            deger = deger == null ? '—' : sayiYaz(deger) + (item.birim ? ' ' + item.birim : '');
        else if (column == 'kilometre')
            deger = deger == null ? '' : Number(deger).toLocaleString('tr-TR');
        else if (column == 'seferNo' && item.seferNo && item.seferDurumu == 'İnceleniyor')
            deger = <span>{item.seferNo} <span className='badge badge-light-warning' title='Seferin aracı fişin aracından farklı ya da boş; maliyet raporları onaylanana kadar saymaz'>İnceleniyor</span></span>;
        else if (column == 'belgeNo' && item.mukerrerOnayi)
            deger = <span>{item.belgeNo} <span className='badge badge-light-info' title='Aynı firma ve belge no başka fişte de var; kullanıcı onayıyla kaydedildi'>aynı belge no</span></span>;

        return <td className={className} onClick={() => setItemSelected(item.yakitKaydiId)} onDoubleClick={() => updateKayit(item.yakitKaydiId)}>{deger}</td>;
    }

    // Dip toplam (Ambar / HGS listesi gibi): filtrelenmiş bütün kayıtlar; farklı dövizde tutar, farklı birimde miktar yazılmaz.
    const getTotalValue = (column: string, columnIndex: number, className: string | undefined) => {
        const t = data.toplamlar;

        if (columnIndex == 0)
            return <td className={className}>Toplam</td>;
        if (!t)
            return <td className={className}></td>;

        if (column == 'toplamMiktar')
            return <td className={className}>{t.toplamMiktar == null ? '' : sayiYaz(t.toplamMiktar) + (t.birim ? ' ' + t.birim : '')}</td>;
        if (column == 'toplamNet' || column == 'toplamKdv' || column == 'toplamBrut') {
            const deger = column == 'toplamNet' ? t.toplamNet : column == 'toplamKdv' ? t.toplamKdv : t.toplamBrut;
            return <td className={className}>{t.farkliDoviz ? FARKLI_DOVIZ : sayiYaz(deger)}</td>;
        }
        if (column == 'dovizCinsi')
            return <td className={className}>{t.farkliDoviz ? '' : t.dovizCinsi}</td>;
        if (column == 'toplamBrutTL')
            return <td className={className}>{sayiYaz(t.toplamBrutTL)}</td>;

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <YakitListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.list.filter(x => x.isSelected).length}
                    onSearchSubmit={onSearchSubmit}
                    deleteFunction={deleteKayit}
                    updateFunction={updateKayit}
                    iceAktar={() => setIceAktarAcik(true)}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.yakitKaydiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.yakitKaydiId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.list.length > 0 && (
                                        <tfoot>
                                            <tr className='fw-bolder text-gray-800'>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment key={column.name}>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.list.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>

            <YakitIceAktarModal
                show={iceAktarAcik}
                onClose={() => setIceAktarAcik(false)}
                onAktarildi={() => { setIceAktarAcik(false); getData({ ...filter, currentPage: 1, skip: 0 }); }}
                ornekExcel={ornekExcel}
            />
        </React.Fragment>
    )
}

export default YakitList;
